<div class="webinar swiper-no-swiping">
    <div class="row">
        <div class="text" [innerHTML]="title | safeHtml"></div>
      <div class="buttons">
        <img class="calendar-icon clickable" *ngIf="!!task.program" (click)="onDownload($event)" [src]="'assets/icon/calendar-download.svg'" alt="Download iCalendar Event" />
        <button (click)="onClick($event)">{{'__JOURNEY_WEBINAR_BUTTON__' | translate}}</button>
      </div>
    </div>
</div>
